import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "dialog-table" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { class: "row no-wrap items-center" }
const _hoisted_7 = { style: {"font-weight":"500","align-self":"flex-start"} }
const _hoisted_8 = {
  key: 3,
  class: "q-ml-xs inline-flex self-start"
}
const _hoisted_9 = {
  key: 0,
  class: "shrink-col"
}
const _hoisted_10 = {
  key: 1,
  class: "shrink-col"
}
const _hoisted_11 = {
  key: 2,
  class: "shrink-col"
}
const _hoisted_12 = {
  key: 3,
  class: "cell-actions"
}
const _hoisted_13 = ["title", "onClick"]
const _hoisted_14 = { class: "q-ml-sm" }
const _hoisted_15 = {
  key: 0,
  style: {"display":"contents"}
}
const _hoisted_16 = { class: "pos_cell" }
const _hoisted_17 = { class: "row no-wrap items-baseline q-ml-md" }
const _hoisted_18 = {
  key: 0,
  class: "shrink-col pos_cell"
}
const _hoisted_19 = { style: {"padding-left":"6px"} }
const _hoisted_20 = {
  key: 1,
  class: "shrink-col pos_cell"
}
const _hoisted_21 = { style: {"padding-left":"6px"} }
const _hoisted_22 = {
  key: 2,
  class: "shrink-col pos_cell"
}
const _hoisted_23 = {
  key: 3,
  class: "pos_cell"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bill_row = _resolveComponent("bill-row")!
  const _component_movement_row = _resolveComponent("movement-row")!
  const _component_project_row = _resolveComponent("project-row")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_native_input = _resolveComponent("native-input")!
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_position_row = _resolveComponent("position-row")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _cache[0] || (_cache[0] = _createElementVNode("th", null, null, -1)),
          (_ctx.showSums)
            ? (_openBlock(), _createElementBlock("th", _hoisted_2, "%"))
            : _createCommentVNode("", true),
          (_ctx.showSums)
            ? (_openBlock(), _createElementBlock("th", _hoisted_3, _toDisplayString(_ctx.$t('amount_lower')), 1))
            : _createCommentVNode("", true),
          (_ctx.showSums)
            ? (_openBlock(), _createElementBlock("th", _hoisted_4, _toDisplayString(_ctx.$t('debit_lower')), 1))
            : _createCommentVNode("", true),
          (!_ctx.hideRemoveBtn)
            ? (_openBlock(), _createElementBlock("th", _hoisted_5))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.theModel, (row, idx) => {
          return (_openBlock(), _createElementBlock("tbody", {
            style: {"display":"contents"},
            key: 'conn_line_'+idx
          }, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(idx + 1) + ". ", 1),
                  (row.bill && !(row.nonExistent == true && _ctx.showNonExistent))
                    ? (_openBlock(), _createBlock(_component_bill_row, {
                        key: 0,
                        el: row.bill,
                        "bill-type": row.billRowType
                      }, null, 8, ["el", "bill-type"]))
                    : (row.movement && (row.nonExistent == true && _ctx.showNonExistent || !row.nonExistent))
                      ? (_openBlock(), _createBlock(_component_movement_row, {
                          key: 1,
                          el: row.movement,
                          "show-positions": false
                        }, null, 8, ["el"]))
                      : (row.project)
                        ? (_openBlock(), _createBlock(_component_project_row, {
                            key: 2,
                            el: row.project
                          }, null, 8, ["el"]))
                        : _createCommentVNode("", true),
                  (_ctx.showLockStatus && _ctx.rowLockStatus(row))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                        _createVNode(_component_q_tooltip, {
                          anchor: "top middle",
                          self: "center middle"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.rowLockStatus(row) === 'locked_by_other' ? _ctx.$t('entity_locked_other_user') : _ctx.$t('entity_locked_or_other_reason')), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_q_icon, {
                          name: "lock",
                          size: "16px",
                          color: "warning"
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.showSums)
                ? (_openBlock(), _createElementBlock("td", _hoisted_9, [
                    _createVNode(_component_native_input, {
                      ref_for: true,
                      ref: 'percent_input_'+idx,
                      modelValue: row.percent,
                      "onUpdate:modelValue": ($event: any) => ((row.percent) = $event),
                      "input-type": "number",
                      "edit-on-click": true,
                      "min-number-value": 0,
                      "max-number-value": (row.maxPercent ? row.maxPercent : this.maxPercent) || undefined,
                      "disabled-field": !row.canEditAmounts,
                      onBlur: ($event: any) => (_ctx.recalcRow(row, 'percent'))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "max-number-value", "disabled-field", "onBlur"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showSums)
                ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                    _createVNode(_component_native_input, {
                      ref_for: true,
                      ref: 'amount_input_'+idx,
                      modelValue: row.amount,
                      "onUpdate:modelValue": ($event: any) => ((row.amount) = $event),
                      "input-type": "number",
                      "edit-on-click": true,
                      "min-number-value": 0,
                      "max-number-value": (row.limitAmount ? row.limitAmount : (row.maxAmount ? row.maxAmount : this.maxAmount)) || undefined,
                      "disabled-field": !row.canEditAmounts,
                      onBlur: ($event: any) => (_ctx.recalcRow(row, 'amount'))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "max-number-value", "disabled-field", "onBlur"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showSums)
                ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                    _createVNode(_component_native_input, {
                      ref_for: true,
                      ref: 'debit_input_'+idx,
                      modelValue: row.debit,
                      "onUpdate:modelValue": ($event: any) => ((row.debit) = $event),
                      "input-type": "number",
                      "edit-on-click": true,
                      "min-number-value": 0,
                      "max-number-value": row.maxDebit || undefined,
                      "disabled-field": !row.canEditDebits,
                      onBlur: ($event: any) => (_ctx.recalcRow(row, 'debit'))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "max-number-value", "disabled-field", "onBlur"])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.hideRemoveBtn)
                ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                    (!(row.nonExistent == true && _ctx.showNonExistent) && (row.canBeDeleted || !this.maxAmount))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "table-remove",
                          title: _ctx.$t('remove'),
                          onClick: ($event: any) => (_ctx.cur_idx = idx)
                        }, [
                          _createVNode(_component_app_icon, {
                            name: "close",
                            width: "16px",
                            color: "#979797",
                            "hover-color": "#616161",
                            cursor: "pointer"
                          }),
                          _createVNode(_component_q_menu, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_card, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_card_section, { class: "row items-center" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_avatar, {
                                        icon: "delete",
                                        size: "md",
                                        color: "grey",
                                        "text-color": "white"
                                      }),
                                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("sure_delete")), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_q_card_actions, {
                                    onKeydown: _ctx.windowKeyDown,
                                    align: "right"
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createVNode(_component_q_btn, {
                                        size: "sm",
                                        flat: "",
                                        label: _ctx.$t('cancel'),
                                        color: "dark",
                                        ref_for: true,
                                        ref: 'cancelbtn'+idx
                                      }, null, 8, ["label"]), [
                                        [_directive_close_popup]
                                      ]),
                                      _withDirectives(_createVNode(_component_q_btn, {
                                        size: "sm",
                                        flat: "",
                                        label: _ctx.$t('remove'),
                                        autofocus: "",
                                        color: "dark",
                                        ref_for: true,
                                        ref: 'okbtn'+idx,
                                        onClick: ($event: any) => (_ctx.remove(idx))
                                      }, null, 8, ["label", "onClick"]), [
                                        [_directive_close_popup]
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["onKeydown"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ], 8, _hoisted_13))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (row.movement)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.movement.Items, (storagepos, idsx) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: 'stp'+idsx
                    }, [
                      _createElementVNode("td", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createTextVNode(_toDisplayString(idsx + 1) + ")  ", 1),
                          _createVNode(_component_position_row, {
                            id: storagepos.Id,
                            el: _ctx.getPositionFromNameInstance(storagepos),
                            "hide-info-btn": true
                          }, null, 8, ["id", "el"])
                        ])
                      ]),
                      (_ctx.showSums)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
                            _createElementVNode("span", _hoisted_19, _toDisplayString(storagepos.ItemQuantity), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.showSums)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_20, [
                            _createElementVNode("span", _hoisted_21, _toDisplayString(storagepos.TotalAmount), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.showSums)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_22))
                        : _createCommentVNode("", true),
                      (!_ctx.hideRemoveBtn)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_23))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ]))
}